<template>
  <div class="wrapper">
    <el-dialog
        :title="rowId ? '编辑角色' : '新增角色'"
        :visible.sync="showAddOrEdit"
        width="900px"
        :before-close="cancelFun"
        class="role-dialog"
    >
      <div>
        <el-form ref="form" :model="formData" :rules="rules" label-width="130px" class="role-form">
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="角色名" prop="roleName">
                <el-input v-model="formData.roleName" placeholder="请输入角色名" clearable class="form-input"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="描述" prop="remark">
                <el-input
                    type="textarea"
                    :rows="4"
                    maxlength="200"
                    show-word-limit
                    v-model="formData.remark"
                    placeholder="请输入角色描述（选填）"
                    class="form-textarea"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelFun" size="small">取 消</el-button>
        <el-button type="primary" @click="submitFun" size="small">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { addRole, editRole, getRoleDetail } from './api';

export default {
  name: 'SystemRoleAddOrEdit',
  props: {
    showAddOrEdit: {
      type: Boolean,
      default: false,
    },
    rowId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      formData: {
        roleName: '',
        remark: ''
      },
      rules: {
        roleName: [
          { required: true, message: '该项不能为空', trigger: 'blur' }
        ],
        remark: [
          { max: 200, message: '角色描述不能超过200个字符', trigger: 'blur' }
        ]
      }
    }
  },

  mounted() {
    if (this.rowId) this.getRoleDetail()
  },

  methods: {
    submitFun() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          // 编辑
          await (this.rowId ? editRole : addRole)(this.formData).then(() => {
            this.$message.success(this.rowId ? '编辑成功' : '新增成功');
            this.$emit("closeDialog",true);
          })
        } else {
          return false;
        }
      })
    },
    async getRoleDetail() {
      this.formData = await getRoleDetail({ id: this.rowId });
    },
    cancelFun() {
      this.$emit("closeDialog");
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  width: 100%;
}

// 对话框样式
.role-dialog {
  ::v-deep .el-dialog {
    border-radius: 8px;
    overflow: hidden;
  }

  ::v-deep .el-dialog__header {
    background: linear-gradient(135deg, #409EFF 0%, #66b1ff 100%);
    padding: 20px 24px;
    border-bottom: none;

    .el-dialog__title {
      color: #fff;
      font-size: 18px;
      font-weight: 600;
    }

    .el-dialog__close {
      color: #fff;
      font-size: 20px;

      &:hover {
        color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  ::v-deep .el-dialog__body {
    padding: 24px;
    background: #f5f7fa;
  }

  ::v-deep .el-dialog__footer {
    padding: 16px 24px;
    background: #fff;
    border-top: 1px solid #e4e7ed;
  }

  ::v-deep .el-form-item__label {
    font-weight: 500;
    color: #606266;
    font-size: 14px;
  }

  ::v-deep .el-form-item {
    margin-bottom: 20px;
  }
}

.scroll-wrap {
  max-height: 65vh;
  overflow-y: auto;
  padding-right: 8px;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 3px;

    &:hover {
      background: #a8a8a8;
    }
  }
}

.role-form {
  .form-input {
    width: 100%;
    max-width: 400px;

    ::v-deep .el-input__inner {
      border-radius: 4px;
      transition: all 0.3s ease;
      text-align: left;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }

  .form-textarea {
    width: 100%;
    max-width: 500px;

    ::v-deep .el-textarea__inner {
      border-radius: 4px;
      transition: all 0.3s ease;
      resize: vertical;

      &:focus {
        border-color: #409EFF;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
      }

      &:hover {
        border-color: #c0c4cc;
      }
    }
  }
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  .el-button {
    padding: 10px 24px;
    border-radius: 4px;
    font-weight: 500;
    transition: all 0.3s ease;

    &.el-button--primary {
      background: linear-gradient(135deg, #66b1ff 0%, #409EFF 100%);
      border: none;

      &:hover {
        background: linear-gradient(135deg, #409EFF 0%, #337ecc 100%);
        box-shadow: 0 6px 20px rgba(64, 158, 255, 0.45), 0 3px 8px rgba(64, 158, 255, 0.25);
        transform: translateY(-2px);
      }
    }

    &:not(.el-button--primary) {
      &:hover {
        color: #409EFF;
        border-color: #409EFF;
        background-color: #ecf5ff;
      }
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .role-dialog {
    ::v-deep .el-dialog {
      width: 95% !important;
      margin: 5vh auto !important;
    }
  }

  .form-input,
  .form-textarea {
    max-width: 100% !important;
  }
}
</style>
